import React from 'react';

export const PageHeader = ({ title, subtitle, actions, kicker, badge }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
    <div>
      {kicker && <div className="text-xs uppercase tracking-[0.18em] pp-mint mb-1">{kicker}</div>}
      <div className="flex items-center gap-3 flex-wrap">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
        {badge}
      </div>
      {subtitle && <p className="text-sm text-muted-foreground mt-1 max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export const PlanBadge = ({ plan }) => {
  const map = {
    free: { label: 'Starter', cls: 'border-[rgba(168,230,206,0.4)] pp-mint' },
    pro: { label: 'Pro', cls: 'border-[rgba(201,168,76,0.5)] pp-gold' },
    business: { label: 'Business', cls: 'border-[rgba(201,168,76,0.6)] pp-gold' },
  };
  const p = map[plan] || { label: plan || 'Starter', cls: 'border-[rgba(168,230,206,0.4)] pp-mint' };
  return (
    <span data-testid="dashboard-plan-badge" className={`text-[11px] font-semibold uppercase tracking-wide px-3 py-1 rounded-full border ${p.cls} bg-[rgba(62,180,137,0.08)]`}>
      Plan {p.label}
    </span>
  );
};

export const priorityColor = (p) => ({
  low: { bg: 'rgba(45,74,62,0.25)', text: '#A6C3B4', label: 'Baja' },
  medium: { bg: 'rgba(168,230,206,0.18)', text: '#3EB489', label: 'Media' },
  high: { bg: 'rgba(201,168,76,0.2)', text: '#C9A84C', label: 'Alta' },
  urgent: { bg: 'rgba(62,180,137,0.28)', text: '#3EB489', label: 'Urgente' },
}[p] || { bg: 'rgba(168,230,206,0.18)', text: '#3EB489', label: p });

export const categoryColor = (c) => ({
  meeting: { bg: 'rgba(201,168,76,0.18)', border: 'rgba(201,168,76,0.4)', text: '#C9A84C', label: 'Reunión' },
  task: { bg: 'rgba(62,180,137,0.16)', border: 'rgba(168,230,206,0.4)', text: '#3EB489', label: 'Tarea' },
  personal: { bg: 'rgba(45,74,62,0.22)', border: 'rgba(45,74,62,0.5)', text: '#A6C3B4', label: 'Personal' },
  urgent: { bg: 'rgba(62,180,137,0.24)', border: 'rgba(62,180,137,0.6)', text: '#3EB489', label: 'Urgente' },
}[c] || { bg: 'rgba(62,180,137,0.16)', border: 'rgba(168,230,206,0.4)', text: '#3EB489', label: c });

export const money = (n) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n || 0);
